import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "iyzico"
    }}>{`Iyzico`}</h2>
    <p>{` iyzico is one of Turkey's most well-known payment gateways. iyzico provides safe payment solutions to internet businesses and individuals of various sizes. You can quickly and easily incorporate the iyzico payment into your e-commerce website and begin accepting payments.`}</p>
    <h3 {...{
      "id": "iyzico-integrate-inside-pickbazar"
    }}>{`Iyzico integrate inside PickBazar.`}</h3>
    <p>{`Please follow & complete this steps for Iyzico integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`Inside api there is `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. You have to copy & paste this line of codes inside the `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. We will discuss later about how to create those API keys in Iyzico.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`# Remove sandbox- for Production

IYZIPAY_BASE_URL=[https://sandbox-api.iyzipay.com]

IYZIPAY_API_KEY=[YOUR_KEY_HERE]

IYZIPAY_SECRET_KEY=[YOUR_SECRET_KEY_HERE]

SHOP_URL=[YOUR_SHOP_URL]
`}</code></pre>
    <b>SHOP_URL=[YOUR_SHOP_URL]</b> This parameter is must have in .env file when Iyzico is using. Otherwise the payment redirection will be broken.
    <ul>
      <li parentName="ul">{`To activate Paypal go to settings from PickBazar admin dashboard. Inside settings you will find configure payment option. (e.g. webhook URL is coming from local development. This static link will dynamically generated in live environment)`}</li>
    </ul>
    <p><img alt="admin-pickbazar-settings" src={require("../images/payment-images/admin-settings.jpg")} />{`
`}<img alt="iyzico-pickbazar-dashboard" src={require("../images/payment-images/iyzico-pickbazar-dashboard.png")} /></p>
    <h2 {...{
      "id": "how-to-create--setup-iyzico-information-properly"
    }}>{`How to create & setup Iyzico information properly?`}</h2>
    <ul>
      <li parentName="ul">{`Create an account in `}<a parentName="li" {...{
          "href": "https://merchant.iyzipay.com/"
        }}>{`https://merchant.iyzipay.com/`}</a></li>
      <li parentName="ul">{`Create a sandbox account in `}<a parentName="li" {...{
          "href": "https://sandbox-merchant.iyzipay.com/"
        }}>{`https://sandbox-merchant.iyzipay.com/`}</a></li>
      <li parentName="ul">{`Choose sandbox if your are testing your development environment.`}</li>
      <li parentName="ul">{`Click on `}<inlineCode parentName="li">{`Setting`}</inlineCode>{` then `}<inlineCode parentName="li">{`Merchant Settings`}</inlineCode>{`. .`}</li>
      <li parentName="ul">{`You will get your Sandbox API credentials. Copy & paste those inside PickBazar app .env file like mentioned above.`}</li>
    </ul>
    <p><img alt="iyzico-dashboard-api-keys" src={require("../images/payment-images/iyzico-dashboard-api-keys.png")} /></p>
    <ul>
      <li parentName="ul">{`You will find the Webhook ID and logo link too.`}</li>
    </ul>
    <p><img alt="iyzico-webhook" src={require("../images/payment-images/iyzico-webhook.png")} /></p>
    <ul>
      <li parentName="ul">{`At last, For going live with your application please follow this official documentation. `}<a parentName="li" {...{
          "href": "https://dev.iyzipay.com/en/api"
        }}>{`https://dev.iyzipay.com/en/api`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      